import { WarningButton } from "@components/buttons/warning";
import { SHStack } from "@components/design-systems";
import { PortfolioCompositionCellDTO } from "@models/platform-analysis/entities/steps/summary";
import { useTheme } from "@mui/material";
import { AnalysisFeeCalculatorStepConfigs as Configs } from "@pages/platform-analysis-v2/_id/steps/fee/calculator/configs";
import { memo } from "react";
import { NumericFormat } from "react-number-format";

interface SummaryPortfolioCompositionCellValueProps {
  cell: PortfolioCompositionCellDTO;
}

export const SummaryPortfolioCompositionCellValue = memo(
  ({ cell }: SummaryPortfolioCompositionCellValueProps) => {
    const { palette } = useTheme();

    const { value, valueInPercent, belowMinimumInvestmentSize } = cell || {};
    const numberValue = Number(value);
    const numberValueInPercent = Number(valueInPercent);
    const invalidValues = isNaN(numberValue) || isNaN(numberValueInPercent);

    if (!value || !valueInPercent) return <></>;

    const fixedDecimalsNumberValue = Number(
      numberValue.toFixed(Configs.DefaultDecimalPlaces),
    );
    const showDecimalPlacesForNumberValue = fixedDecimalsNumberValue % 1 !== 0;

    const fixedDecimalsNumberValueInPercent = Number(
      numberValueInPercent.toFixed(Configs.DefaultDecimalPlaces),
    );
    const showDecimalPlacesForNumberValueInPercent =
      fixedDecimalsNumberValueInPercent % 1 !== 0;

    return (
      <SHStack direction={"row"} width={"100%"} height={"100%"}>
        <SHStack
          width={"65%"}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"end"}
          paddingRight={"5%"}
          borderRight={`1px solid ${palette.secondary[100]}`}
        >
          {belowMinimumInvestmentSize && (
            <SHStack paddingBottom={"5px"}>
              <WarningButton
                title={"This allocation is below the minimum investment size."}
              />
            </SHStack>
          )}
          {invalidValues ? (
            <SHStack alignItems={"center"}>-</SHStack>
          ) : (
            <NumericFormat
              prefix={"$"}
              value={numberValue}
              decimalScale={
                showDecimalPlacesForNumberValue
                  ? Configs.DefaultDecimalPlaces
                  : 0
              }
              fixedDecimalScale={showDecimalPlacesForNumberValue}
              displayType={"text"}
              thousandSeparator
            />
          )}
        </SHStack>

        <SHStack
          width={"35%"}
          alignItems={"center"}
          justifyContent={"center"}
          paddingRight={"5%"}
        >
          <SHStack alignItems={"end"} justifyContent={"end"} width={"100%"}>
            {invalidValues ? (
              <SHStack alignItems={"center"}>-</SHStack>
            ) : (
              <NumericFormat
                suffix={"%"}
                value={numberValueInPercent}
                decimalScale={
                  showDecimalPlacesForNumberValueInPercent
                    ? Configs.DefaultDecimalPlaces
                    : 0
                }
                fixedDecimalScale={showDecimalPlacesForNumberValueInPercent}
                displayType={"text"}
              />
            )}
          </SHStack>
        </SHStack>
      </SHStack>
    );
  },
);
